module.exports = __webpack_public_path__ + "static/media/ignoto.6b974cf7.jpg";